import ThumbUpIcon from "@assets/icons/thumb-up.svg";
import ThumbDownIcon from "@assets/icons/thumb-down.svg";

import type { ContextRating } from "@interfaces/thread.interface";
import { cn } from "@utils/tailwind.util";
import { View } from "@ui/View";

interface AIContextFooterProps {
  message: string;
  isError: boolean;
  showFeedback: boolean;
  showFeedbackDialogTrigger: boolean;
  feedbackRating?: ContextRating | null;
  onThumbsUp: () => void;
  onThumbsDown: () => void;
  onSubmitReasons: () => void;
}

export function AIContextFooter({
  message,
  isError,
  showFeedback,
  showFeedbackDialogTrigger,
  feedbackRating,
  onThumbsUp,
  onThumbsDown,
  onSubmitReasons,
}: AIContextFooterProps) {
  const hasFeedback = !!feedbackRating;

  if (!message) return null;

  return (
    <div className="w-full border-t dark:border-gray-600 pt-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span
            className={cn("h-1 w-1 inline-block rounded-xl bg-emerald-400", {
              "bg-red-600": isError,
            })}
          />
          <span className="inline-block align-middle text-xs font-normal text-content-secondary">
            {message}
          </span>
        </div>

        <View.Condition if={showFeedback}>
          <div className="flex items-center gap-1">
            <View.Condition if={showFeedbackDialogTrigger}>
              <span
                onClick={onSubmitReasons}
                className="text-xs underline cursor-pointer text-content-secondary dark:text-invertedPrimary80"
              >
                Tell us why
              </span>
            </View.Condition>

            <button
              onClick={onThumbsUp}
              disabled={hasFeedback}
              className={cn(
                "cursor-pointer p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-400 dark:text-invertedPrimary80 transition-colors",
                {
                  "[&_svg]:fill-current": feedbackRating === "thumbs_up",
                  "cursor-default hover:bg-transparent dark:hover:bg-transparent": hasFeedback,
                }
              )}
            >
              <ThumbUpIcon width={14} height={14} />
            </button>
            <button
              onClick={onThumbsDown}
              disabled={hasFeedback}
              className={cn(
                "cursor-pointer p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-400 dark:text-invertedPrimary80 transition-colors",
                {
                  "[&_svg]:fill-current": feedbackRating === "thumbs_down",
                  "cursor-default hover:bg-transparent dark:hover:bg-transparent": hasFeedback,
                }
              )}
            >
              <ThumbDownIcon width={14} height={14} />
            </button>
          </div>
        </View.Condition>
      </div>
    </div>
  );
}
